<template lang="pug">
   div(class="broadcast-sender-container") Broadcast sent by {{ broadcasterName }}
 </template>

<script>
export default {
  name: "CommentBroadcastSender",
  props: {
    broadcasterName: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="stylus" scoped>
.broadcast-sender-container
 padding 4px 8px
 background #FAFAFA
 border 1px solid #BFBFBF
 border-radius 8px
 font-size 10px
 font-weight 500
 letter-spacing 0.005em
 height fit-content
 margin-bottom: 4px
 text-wrap nowrap
</style>



// WEBPACK FOOTER //
// src/components/CommentBroadcastSender.vue